export default "__VITE_ASSET__B_2WrmIx__"